import { 
  CHECK_ALL_NOTIFICATIONS,
  CHECK_ALL_NOTIFICATIONS_ERROR,
  CHECK_ALL_NOTIFICATIONS_SUCCESS,
  CHECK_NOTIFICATION,
  CHECK_NOTIFICATION_ERROR,
  CHECK_NOTIFICATION_SUCCESS,
  GET_NOTIFICATIONS, 
  GET_NOTIFICATIONS_ERROR, 
  GET_NOTIFICATIONS_SUCCESS, 
  GET_ALL_NOTIFICATIONS,
  GET_ALL_NOTIFICATIONS_SUCCESS,
  GET_ALL_NOTIFICATIONS_ERROR
} from 'redux/constants/Notification';

/**
 * GET NOTIFICATIONS
 * @returns 
 */
export const getNotifications = (query) => {
  return {
    type: GET_NOTIFICATIONS,
    payload: {
      query
    }
  }
};

/**
 * GET NOTIFICATIONS SUCCESS
 * @param {*} data 
 * @returns 
 */
export const getNotificationsSuccess = (data) => {
  return {
    type: GET_NOTIFICATIONS_SUCCESS,
    data
  }
};

/**
 * GET NOTIFICATIONS ERROR
 * @param {*} message 
 * @returns 
 */
export const getNotificationsError = (message) => {
  return {
    type: GET_NOTIFICATIONS_ERROR,
    message
  }
};

/**
 * CHECK NOTIFICATION
 * @returns 
 */
 export const checkNotification = (id,  cb = () => {}) => {
  return {
    type: CHECK_NOTIFICATION,
    payload: {
      id,
      cb
    }
  }
};

/**
 * CHECK NOTIFICATION SUCCESS
 * @param {*} data 
 * @returns 
 */
export const checkNotificationSuccess = (data) => {
  return {
    type: CHECK_NOTIFICATION_SUCCESS,
    data
  }
};

/**
 * CHECK NOTIFICATION ERROR
 * @param {*} message 
 * @returns 
 */
export const checkNotificationError = (message) => {
  return {
    type: CHECK_NOTIFICATION_ERROR,
    message
  }
};


/**
 * CHECK ALL NOTIFICATION
 * @returns 
 */
 export const checkAllNotifications = (cb = () => {}) => {
  return {
    type: CHECK_ALL_NOTIFICATIONS,
    payload: {
      cb
    }
  }
};

/**
 * CHECK ALL NOTIFICATIONS SUCCESS
 * @param {*} data 
 * @returns 
 */
export const checkAllNotificationsSuccess = (data) => {
  return {
    type: CHECK_ALL_NOTIFICATIONS_SUCCESS,
    data
  }
};

/**
 * CHECK ALL NOTIFICATIONS ERROR
 * @param {*} message 
 * @returns 
 */
export const checkAllNotificationsError = (message) => {
  return {
    type: CHECK_ALL_NOTIFICATIONS_ERROR,
    message
  }
};

/**
 * GET ALL NOTIFICATIONS
 * @returns 
 */
 export const getAllNotifications = () => {
  return {
    type: GET_ALL_NOTIFICATIONS,
    payload: { }
  }
};

/**
 * GET ALL NOTIFICATIONS SUCCESS
 * @param {*} data 
 * @returns 
 */
export const getAllNotificationsSuccess = (data) => {
  return {
    type: GET_ALL_NOTIFICATIONS_SUCCESS,
    data
  }
};

/**
 * GET ALL NOTIFICATIONS ERROR
 * @param {*} message 
 * @returns 
 */
export const getAllNotificationsError = (message) => {
  return {
    type: GET_ALL_NOTIFICATIONS_ERROR,
    message
  }
};